
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { push } from "redux-first-history";
import { map } from "lodash-es";
import { LandingPage } from "@dev/ee-api/ee-api-models";
import { TableRowNameLink, TemplatePreview, Typography } from "@dev/ee-components";
import { safelyEncodeBase64Url } from "@dev/ee-tools";

import { getApiPath } from "@/services/Secuirty";
import { LandingPagePaths } from "@/services/dictionaries/Paths";
import { TemplatePreviewStart } from "@/store/landingPageList/actions";
import { ViewButtonComponent } from "../components/ViewButtonComponent";

export const useTableRows = (landingPagesList: LandingPage[], setOpenPreview: (open: boolean) => void) =>  {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onPreviewClick = (name: string): void => {
        setOpenPreview(true);
        dispatch(TemplatePreviewStart(name));
    };

    return map(landingPagesList, (landingPage: LandingPage) => {
        const linkWithoutProtocol = landingPage.LandingUrl?.replace("https://", "") || '';
        const isPreviewDisabled = !landingPage.MediumScreenshot;
        const screenshotPath = landingPage?.MediumScreenshot ? `${getApiPath()}/userfile${landingPage?.MediumScreenshot}` : '';

        return {
            preview: (
                <TemplatePreview
                    split={false}
                    screenshot={screenshotPath}
                    onClick={(): void => {
                        if (!isPreviewDisabled) {
                            onPreviewClick(landingPage.Name);
                        }
                    }}
                    disabled={isPreviewDisabled}
                />
            ),
            linkInBioName: (
                <Typography variant="body1" className="link-in-bio">
                    <TableRowNameLink
                        onClick={(): void => {
                            dispatch(push(LandingPagePaths.LandingPageCreator.replace(':name', safelyEncodeBase64Url(landingPage.Name))));
                        }}
                    >
                        {landingPage.Name}
                    </TableRowNameLink>
                </Typography>
            ),
            link: <Typography variant="body1" className="link-in-bio">{linkWithoutProtocol || t('nolinkset')}</Typography>,
            view: <ViewButtonComponent landingPage={landingPage} />,
            rowID: landingPage.Name,
        }
    });
};
